import Tasks from './tasksContainer';
import NewTask from './newTask';
import TasksList from './tasksList';
import EditTask from './editTask';

export {
	Tasks,
	NewTask,
	TasksList,
	EditTask,
};

export * from './new-tasks';



// WEBPACK FOOTER //
// ./src/browser/components/tasks/index.js